module.exports = __webpack_public_path__ + "img/features_social interactions.20cb0ad9.png";